module.exports = __webpack_public_path__ + "img/botella_blanco_1.e91937b5.jpg";